import { Injectable } from '@angular/core';
import { ngContentInjector } from './ng-content-injection.directive';

@Injectable()
export class NgContentInjectionService {
    hide() {
        ngContentInjector.Instance.OnDestroyed.emit(true);
    }
}
